import chairmanImage from '../assets/images/chairman.png'; // Adjust the path as needed

const ChairmanSection = () => {
  
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">

      <div className="row justify-content-center mt-3 pb-4">
          <div className="col-md-12  heading-section ftco-animate text px-4">
            <h2 className="mb-4 text-success text-center">
            Management 
            </h2>   
          </div>
        </div>
          
        <div className="row mt-3">
          <div className=" col-md-12 order-md-first ">
            <div className="text px-4">
              <h2 className="mb-4 text-secondary"> Chairman’s Message </h2>
        
             
              <p>
              <img src={chairmanImage} alt="SRN Chairman" className="img-fluid" width={400} height={200} />
       
                            It is indeed a great pleasure to introduce SRN Educational and Social Welfare Trust
              which strives to ensure the holistic development of a student and in turn the society. SRN
              Matriculation has highly equipped itself with sound technological tools to face, survive and
              live amidst the growing complexities of the modern world. Human brain is the most
              complex and wonderful entity created by nature in the entire universe. If the brain is ill
              nurtured, it could turn up into the most deadly weapon against humanity. Keeping this in
              mind, SRN Matriculation strives for continuous improvement in its curriculum, teaching and
              learning methodologies by adapting the proven developmental and educational
              psychological methods.
              </p>

              <p>Excess information dumping also poses severe problems to a student and hampers
their growth. These are stress, aversion towards learning and even towards the school are
some of the major problems faced today. This is purely because of the conventional
learning methodologies which are outdated and have failed to keep up with growing
transformations in the society. These factors are the reasons why a child considers
education as a burden. If this is neglected, it poses serious damage to the society and
indirectly it has economic implications for our country.</p>

              <p>The prime aim of SRN Matriculation is ''Celebrating Education''. The curriculum,
teaching and learning methodologies are adopted and designed in such a way that the
students enjoy it. Highest standard study materials are prescribed to meet the needs of the
highly competitive world. A highly conducive environment is ensured for promoting
creativity, innovation and intellectual stimulation of students. SRN Educational and Social
Welfare Trust is also aiming to provide quality and affordable education even for the
unaffordable. I am very sure this beautiful journey on the path of education is going to be
exciting, challenging and very rewarding. I also believe this is the most exciting time for
education in India. I sincerely request all the support and co-operation from the parents. I
also wish my dear children to celebrate education and come up with flying colours in life.</p>

             
            </div>
            <h5 className=' px-4 text-right'><strong>S. Sasikumar </strong><span className="qualification"> B.E.,</span> <br/><strong>Correspondent,</strong><br/>
SRN Matriculation School,<br/>
              Sathyamangalam.</h5>
              <h5 className='px-4 text-right'> <br/><strong>Chairman,</strong><br/>
              SRN Educational and Social Welfare Trust,<br/>
Sathyamangalam.</h5>
          
          </div>
        </div>  
      </div>
      <hr className="custom-hr"/>
    </section>
  );
};

export default ChairmanSection;
